import { getForecastingByIdRouteUrl, ROUTES } from '@futrli/shared-services';
import React from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';

import { ForecastingOnboardingStart } from './forecasting-onboarding-start';
import { BUDGET_ONBOARDING_STEP, SCENARIO_ONBOARDING_STEP } from './const';
import { BudgetOnboardingContainer } from './budget/budget-onboarding-container';
import { ScenarioOnboardingContainer } from './scenario/scenario-onboarding-container';
import { ScenarioWithInvoicesOnboardingContainer } from './scenario/scenario-with-invoices-onboarding-container';
import { DataGridScrollProvider } from '../detail/predictions/data-grid-scroll-context';

export const ForecastingOnboardingContainer = () => {
  const { workspaceId, organisationId, forecastId } = useParams();
  const baseRoute = `${getForecastingByIdRouteUrl(workspaceId!, organisationId!, forecastId!)}${
    ROUTES.ONBOARDING_ROUTE
  }`;
  return (
    <DataGridScrollProvider>
      <Routes>
        <Route path="/" element={<ForecastingOnboardingStart />} />
        {/* One-year P&L only */}
        <Route path={`${ROUTES.BUDGET}${ROUTES.ONBOARDING_STEP}`} element={<BudgetOnboardingContainer />} />
        <Route
          path={`${ROUTES.BUDGET}${ROUTES.ONBOARDING_STEP}${ROUTES.ONBOARDING_CATEGORY}`}
          element={<BudgetOnboardingContainer />}
        />
        <Route
          path={ROUTES.BUDGET}
          element={<Navigate to={`${baseRoute}${ROUTES.BUDGET}${BUDGET_ONBOARDING_STEP.START_MONTH}`} />}
        />
        {/* 3-year cash flow forecast */}
        <Route path={`${ROUTES.SCENARIO}${ROUTES.ONBOARDING_STEP}`} element={<ScenarioOnboardingContainer />} />
        <Route
          path={`${ROUTES.SCENARIO}${ROUTES.ONBOARDING_STEP}${ROUTES.ONBOARDING_CATEGORY}`}
          element={<ScenarioOnboardingContainer />}
        />
        <Route
          path={ROUTES.SCENARIO}
          element={<Navigate to={`${baseRoute}${ROUTES.SCENARIO}${SCENARIO_ONBOARDING_STEP.CASH_FLOW_IMPORTANT}`} />}
        />
        {/* 3-year cash flow with invoices forecast */}
        <Route
          path={`${ROUTES.SCENARIO_WITH_INVOICES}${ROUTES.ONBOARDING_STEP}`}
          element={<ScenarioWithInvoicesOnboardingContainer />}
        />
        <Route
          path={`${ROUTES.SCENARIO_WITH_INVOICES}${ROUTES.ONBOARDING_STEP}${ROUTES.ONBOARDING_CATEGORY}`}
          element={<ScenarioWithInvoicesOnboardingContainer />}
        />
        <Route
          path={ROUTES.SCENARIO_WITH_INVOICES}
          element={
            <Navigate
              to={`${baseRoute}${ROUTES.SCENARIO_WITH_INVOICES}${SCENARIO_ONBOARDING_STEP.CASH_FLOW_IMPORTANT}`}
            />
          }
        />
      </Routes>
    </DataGridScrollProvider>
  );
};
